import axios from "axios";
import { setInterceptors } from "./interceptor";
import store from "@/store";
import router from "@/router";

const version = process.env.VUE_APP_API_VERSION;
const protocolHost = () => {
  return `${location.protocol}//${location.host}`;
};

export const setServiceUid = async () => {
  let serviceUid = store.state.common.serviceInfo.uid;
  if (!serviceUid) {
    const serviceCode =
      router.currentRoute.value.params.serviceCode.toUpperCase();
    const response = await publicInstance().get(`service/${serviceCode}`);
    store.commit("common/FETCH_SERVICE_INFO", response.data.data);
    serviceUid = response.data.data.uid;
  }
  return serviceUid;
};

export function publicInstance() {
  return setInterceptors(
    axios.create({
      baseURL: `${protocolHost()}/aibos/client/api/v${version}/public/`,
    })
  );
}

export function privateInstance() {
  const accessToken = store.state.member.accessToken;
  const instance = axios.create({
    baseURL: `${protocolHost()}/aibos/client/api/v${version}/`,
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return setInterceptors(instance);
}

export function basicInstance() {
  return setInterceptors(
    axios.create({
      baseURL: `${protocolHost()}/aibos/client/api/v${version}/`,
    })
  );
}

export function loginInstance() {
  return setInterceptors(
    axios.create({
      baseURL: `${protocolHost()}/aibos/client/api/public`,
    })
  );
}
